import { createSlice, current } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  selected: [],
  loading: false,
  error: "",
  isMdDown:""
};

export const saleSlice = createSlice({
  name: "sale",
  initialState,
  reducers: {
    addGst: (state, action) => {
      let items = action.payload;
      state.selected = items;
    },
    cellResponsiveness:(state, action) => {
      let items = action.payload;
      state.isMdDown = items;
    },
    addItem: (state, action) => {
      // state.selected.unshift(action.payload);
      let item = { ...action.payload };
      console.log('storeAddItem', item)
      let gst = localStorage.getItem("gst") || "";
      let gstType = localStorage.getItem("gstType") || "";

      if (gstType == "Item" && gst && gst != "disabled") {
        if (item.salePrice == undefined || item.salePrice == null) {
          let price = parseInt(item.price);
          // let gstAmount = (parseInt(gst) / 100) * price;
          item.gstAmount = (parseInt(gst) / 100) * price;
          // item.salePrice = price + Math.ceil(gstAmount);
          state.selected.unshift(item);
        } else {
          state.selected.unshift(item);
        }
      } else {
        state.selected.unshift(item);
      }
    },
    addTabItem: (state, action) => {
      if (state.selected.length > 0) {
        let found = state.selected.find((i) => i._id == action.payload._id);
        if (found) {
          found.saleQuantity;
          if (found.saleQuantity) {
            found.saleQuantity = parseInt(found.saleQuantity) + 1;
          } else {
            found.saleQuantity = 2;
          }
        } else {
          let item = { ...action.payload };
          let gst = localStorage.getItem("gst") || "";
          let gstType = localStorage.getItem("gstType") || "";

          if (gstType == "Item" && gst && gst != "disabled") {
            if (item.salePrice == undefined || item.salePrice == null) {
              let price = parseInt(item.price);
              // let gstAmount = (parseInt(gst) / 100) * price;
              // item.salePrice = price + Math.ceil(gstAmount);
              item.gstAmount = (parseInt(gst) / 100) * price;
              state.selected.push(item);
            } else {
              state.selected.push(item);
            }
          } else {
            state.selected.push(item);
          }
        }
      } else {
        let item = { ...action.payload };
        let gst = localStorage.getItem("gst") || "";
        let gstType = localStorage.getItem("gstType") || "";

        if (gstType == "Item" && gst && gst != "disabled") {
          if (item.salePrice == undefined || item.salePrice == null) {
            let price = parseInt(item.price);
            item.gstAmount = (parseInt(gst) / 100) * price;
            state.selected.unshift(item);
          } else {
            state.selected.unshift(item);
          }
        } else {
          state.selected.unshift(item);
        }
      }
    },
    editItem: (state, action) => {
      const { index, value, key,packValue, } = action.payload;
      console.log('value', value)
      console.log('keyyy', key)


      console.log('itemmmm', )
      if (key == "batchNo") {
        state.selected[index].batchQty = value.quantity;
        state.selected[index].batchExpiry = value.batchExpiry;
        state.selected[index][key] = value.batchNo;
      } else if(key =="saleBatchNumber") {
        state.selected[index]["saleBatchNumber"] = value?.batchNumber;
      //  const itemBatchBox =  value?.batchNumber?.map((item,index)=> {
      //     return item.box
      //   })
      //   console.log('itemBatchBox', itemBatchBox)
        if(value.box) {
          state.selected[index]["box"] = true

        }
        state.selected[index]["batchPricePerBox"] = Number(value?.newItem?.price);
        state.selected[index]["batchPricePerPiece"] = Number(value?.pricePerPiece);


      }else {
        // state.selected[index][steelWeightKgSale] =

        console.log('index', index)
        console.log('key', key)
        console.log('value', value)
        if(packValue) {
          state.selected[index]["steelWeightKgSale"] = packValue;

        }
      //  selectedForSale[index]?.saleType == "pieces"
        if(key == "salePrice" &&  state.selected[index]?.saleType === "pieces" ) {
          state.selected[index]["pricePerPiece"] = Number(value);

        }else {
          state.selected[index][key] = value;

        }
      }
    },
    editMultiItems: (state, action) => {
      state.selected.forEach((item) => {
        item.selected = action.payload;
      });
    },
    addMultiItems: (state, action) => {
      state.selected = action.payload;
    },
    applyDiscount: (state, action) => {
      const addDiscount = action.payload;
      state.selected.forEach((item) => {
        if (item.selected == true) {
          if (addDiscount < 90) {
            item.saleDiscount = addDiscount;
            item.selected = false;
          } else if (addDiscount > 90) {
            toast.configure();
            toast.info("Cant havae discounts more than 90%");
            item.saleDiscount = 0;
          }
        }
      });
    },
    removeItem: (state, action) => {
      const { index } = action.payload;
      state.selected.splice(index, 1);
    },
    removeSelected: (state, action) => {
      state.selected = [];
    },
    increaseSaleQty: (state, action) => {
      const { _id } = action.payload;
      let copy = JSON.parse(JSON.stringify(current(state.selected)));
      let found = copy.find((item) => item._id == _id);
      if (found) {
        found.saleQuantity += 1;
        state.selected = copy;
      } else {
        let item = JSON.parse(JSON.stringify(action.payload));
        item.saleQuantity = 1;
        state.selected.unshift(item);
      }
    },
    roleRFT: (state, action) => {
      state.selected = action.payload;
    },
    clearSelected: (state, action) => {
      state.selected = [];
    },
  },
});

export const {
  clearSelected,
  addGst,
  addItem,
  removeItem,
  addMultiItems,
  editItem,
  applyDiscount,
  editMultiItems,
  increaseSaleQty,
  roleRFT,
  removeSelected,
  addTabItem,
  cellResponsiveness
} = saleSlice.actions;

export default saleSlice.reducer;
